import { Injectable } from '@angular/core';
import { UsuarioService } from '../usuario/usuario.service';
import { Router } from '@angular/router';
import { LocalService } from '../local/local.service';
import { EmpresaService } from '../empresa/empresa.service';
import { catchError, map, take, tap, throwError } from 'rxjs';
import { ColaboradorService } from '../colaborador/colaborador.service';
import { EscalaService } from '../escala/escala.service';
import { Local } from 'src/app/models/local';
import { LoadingService } from '../loading.service';
import { Usuario } from 'src/app/models/usuario';
import { AdminService } from '../admin/admin.service';
import { UserAdmin } from 'src/app/models/useradmin';
import { Empresa } from 'src/app/models/empresa';
import { AuthStore } from '../auth.store';
import { Colaborador } from 'src/app/models/colaborador';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private usuarioService: UsuarioService,
    private router: Router,
    private localService: LocalService,
    private empresaService: EmpresaService,
    private colaboradorService: ColaboradorService,
    private escalaService: EscalaService,
    private adminUserService: AdminService,
    private loadingService: LoadingService,
    private authStore: AuthStore
  ) { }

  empresaId!: number;

  login(email: string, password: string) {
    let usernameParsed = email.replace(/\D/g, '');
    if (usernameParsed.length < 11) {
      usernameParsed = email;
    }
    this.usuarioService
      .login(usernameParsed, password)
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Usuario;
        }),
        tap((data) => {
          if (!data) return;
          console.log(data, 'user logged');
          this.router.navigate(['']);
          if (data.roles?.includes('USER_ADMIN'))
            this.carregarEmpresasAdmin(data.userId!);
          else if (data.roles?.includes('GESTOR'))
            this.carregarEmpresasGestor(data.id!);
          else {
            this.router.navigate(['login']);
            this.usuarioService.setLogged(false);
            this.usuarioService.logout();
            this.loadingService.presentToast(
              'Voce não possui autorização de acesso. Fale com o administrador.'
            );
          }
        })
      )
      .subscribe();
  }

  signup(account: {
    email: string;
    password: string;
    cpf: string;
    funcao: string;
    name: string;
    telefone: string;
  }) {
    this.usuarioService
      .signup(account.email, account.password)
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Usuario;
        }),
        tap((data) => {
          this.loginForSignUp(account);
        })
      )
      .subscribe();
  }

  private loginForSignUp(account: {
    email: string;
    password: string;
    cpf: string;
    funcao: string;
    name: string;
    telefone: string;
  }) {
    this.usuarioService
      .login(account.email, account.password)
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Usuario;
        }),
        tap((data) => {
          if (!data) return;
          this.criaUserAdm(data, account.cpf, account.funcao, account.name, account.telefone);
        })
      )
      .subscribe();
  }

  async setEmpresaSelect(empresaId: number) {
    await this.loadingService.presentLoading();
    this.empresaService
      .getEmpresas()
      .pipe(
        map((empresas) => {
          if (empresas) {
            return empresas.find((empresa) => empresa.id == empresaId);
          }
          return {} as Empresa;
        }),
        catchError((err: any) => {
          this.loadingService.dismissLoading();
          const message = 'Erro ao alternar de empresa';
          this.loadingService.presentToast(message);
          return throwError(err);
        }),
        tap(async (res) => {
          if (res) {
            this.empresaService.setEmpresaSelect(res);
            const message = `Voce alternou para ${res.nome.toUpperCase()}`;
            this.loadingService.presentToast(message);
            const user = this.authStore.getUser();
            if (user.roles?.includes('USER_ADMIN')) {
              this.carregarEmpresasAdmin(user.userId!, res.id!);
            } else if (user.roles?.includes('GESTOR')) {
              this.carregarEmpresasGestor(user.id, res.id!);
            }
          }
          await this.loadingService.dismissLoading();
        })
      )
      .subscribe();
  }

  carregarEmpresasDesativadas(userId: number) {
    this.empresaService
      .carregaEmpresasByUserId(userId, 'ADMIN', false)
      .pipe(
        tap((res) => {
          this.empresaService.addEmpresas(res);
        })
      )
      .subscribe();
  }

  private criaUserAdm(
    usuario: Usuario,
    cpf: string,
    funcao: string,
    name: string,
    telefone: string
  ) {
    this.adminUserService
      .criaAdmin({
        ativo: true,
        cpf: cpf,
        email: usuario.email,
        deletado: false,
        funcao: funcao,
        loginId: usuario.id,
        nome: name,
        telefone: telefone,
      })
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as UserAdmin;
        }),
        tap((_) => {
          this.loadingService.presentToast('Conta Criada com sucesso');
          this.usuarioService.setLogged(false);
          this.router.navigate(['empresa', 'create']);
        })
      )
      .subscribe();
  }

  public criaEmpresa(cnpj: string, name: string) {
    this.empresaService
      .criaEmpresa({
        ativo: true,
        cnpj,
        nome: name,
      })
      .pipe(
        map((res) => {
          if (res) {
            return res;
          }
          return {} as Empresa;
        }),
        tap((res) => {
          this.usuarioService.setLogged(true);
          // this.empresaService.setEmpresaSelect(res);
          // this.carregarEmpresas(this.usuarioService.getUser());
          // this.logout();
          this.router.navigate(['']);
        })
      )
      .subscribe();
  }

  async carregarEmpresasAdmin(userId: number, empresaId?: number) {
    await this.loadingService.presentLoading();
    if (empresaId) {
      return this.loadEmpresa(empresaId);
    }
    this.empresaService
      .carregaEmpresasByUserId(userId, 'ADMIN', true)
      .pipe(
        catchError((err: any) => {
          return this.handleError(err);
        }),
        tap(async (res) => {
          if (!res[0]) {
            this.router.navigate(['login']);
            this.usuarioService.setLogged(false);
            await this.loadingService.dismissLoading();
            this.loadingService.presentAlertConfirmOrCancel(
              'Empresa',
              '',
              'Voce não possui nenhuma empresa, deseja criar uma?',
              () => this.router.navigate(['empresa', 'create']),
              () => this.logout()
            );
            return;
          }

          const empresaStored = this.empresaService.getEmpresaSelectedStorage();
          if (empresaStored) {
            this.empresaId = empresaStored.id!;
          } else {
            this.empresaId = res[0].id!;
          }

          this.adminUserService.carregarAdmin(userId).pipe(take(1)).subscribe();
          this.carregarEmpresasDesativadas(userId);
          this.carregarLocais();
          this.carregarColab();
          console.log(this.empresaId);
        })
      )
      .subscribe();
  }

  loadEmpresa(empresaId: number) {
    this.empresaId = empresaId;
    this.carregarLocais();
    this.carregarColab();
    return;
  }

  async carregarEmpresasGestor(userId: number, empresaId?: number) {
    await this.loadingService.presentLoading();
    if (empresaId) {
      this.empresaId = empresaId;
      this.carregarLocais();
      this.carregarColab(true, userId);
      return;
    }
    this.empresaService
      .carregaEmpresasByUserId(userId, 'GESTOR', true)
      .pipe(
        catchError((err: any) => {
          return this.handleError(err);
        }),
        tap(async (res) => {
          if (!res[0]) {
            this.router.navigate(['login']);
            await this.loadingService.dismissLoading();
            this.logout();
            this.loadingService.presentToast(
              'Empresa não encontrada. Fale com o Administrador!'
            );
            return;
          }

          const empresaStored = this.empresaService.getEmpresaSelectedStorage();
          if (empresaStored) {
            this.empresaId = empresaStored.id!;
          } else {
            this.empresaId = res[0].id!;
          }
          this.carregarLocais();
          this.carregarColab(true, userId);
        })
      )
      .subscribe();
  }

  handleError(err: any) {
    if (err.error.error == 'Unauthorized') {
      this.logout();
      this.loadingService.presentToast('Token inválido, sessão finalizada!');
      return throwError(err);
    }
    return throwError(err);
  }

  async carregarLocais() {
    console.log(this.empresaId);
    this.localService
      .carregaLocais(this.empresaId)
      .pipe(
        take(1),
        tap((res) => {
          this.carregarEscalas(res);
        })
      )
      .subscribe();
  }

  private async carregarColab(isGestor = false, userId = 0) {
    this.colaboradorService
      .carregaColaboradores(this.empresaId)
      .pipe(
        tap(async (colaboradores) => {
          if (isGestor) {
            this.authStore.setUserGestor(
              colaboradores.find(
                (colaborador) => colaborador.loginId == userId
              ) as Colaborador
            );
          }
          await this.loadingService.dismissLoading();
        })
      )
      .subscribe();
  }

  private carregarEscalas(locais: Local[]) {
    if (locais.length <= 0) return;
    console.log('pass');
    for (let local of locais) {
      console.log(`local is loading ${local.id}`);
      this.escalaService.carregaEscalas(local.id!).pipe(take(1)).subscribe();
    }
  }

  logout() {
    this.usuarioService.logout();
    this.escalaService.limparData();
    this.router.navigate(['login']).then(() => {
      //reload page
      window.location.reload();
    });
  }
}
